module.exports = __webpack_public_path__ + "img/sky.cb8fe210.png";